import React, { useState } from 'react';

import BasicDropdown from '../../../common/BasicDropdown/BasicDropdown';
import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import Label from '../../../common/Labels/Label';

export const ROLE = {
  Admin: 'admin',
  User: 'user',
  All: 'all',
}

export const USER_STATUS = {
  Inactive: 'inactive',
  Active: 'active',
  All: 'all',
}

const ROLE_OPTIONS = [
  {
    id: ROLE.All,
    label: 'All Types',
  },
  {
    id: ROLE.Admin,
    label: 'Admin',
  },
  {
    id: ROLE.User,
    label: 'User',
  },
]

const STATUS_OPTIONS = [
  {
    id: USER_STATUS.All,
    label: 'All Statuses',
  },
  {
    id: USER_STATUS.Active,
    label: 'Active',
  },
  {
    id: USER_STATUS.Inactive,
    label: 'Inactive',
  },
]

export const UserTableFilterModal = ({
  filter = { role: ROLE.All, status: USER_STATUS.All },
  showDialog = false,
  onDialogToggle = () => {},
  onFilterConfirm = () => {},
  onClear = () => {},
}) => {
  const [selectedRole, setSelectedRole] = useState(filter.role);
  const [selectedStatus, setSelectedStatus] = useState(filter.status);

  const handleConfirmation = () => {
    onFilterConfirm({
      role: selectedRole,
      status: selectedStatus,
    });
  }

  return (
    <ConfirmationDialog
      title="Filter"
      confirmButtonText="Apply"
      cancelButtonText="Clear All"
      modalAnimationKey="user-admin-table-filter"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={handleConfirmation}
      onCancel={onClear}
    >
      <div className="flex flex-col w-small-modal mx-2 my-3">
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Type</Label>
          <BasicDropdown
            values={ROLE_OPTIONS}
            selectedValue={selectedRole}
            onValueSelected={setSelectedRole}
            hideLabelInSmallViewports={false}
            dropdownLabel=""
          />
        </div>
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Status</Label>
          <BasicDropdown
            values={STATUS_OPTIONS}
            selectedValue={selectedStatus}
            onValueSelected={setSelectedStatus}
            hideLabelInSmallViewports={false}
            dropdownLabel=""
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default UserTableFilterModal;
